import * as React from 'react';
import { SVGProps } from 'react';

const IconMicSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M8 1a2 2 0 0 0-2 2v4a2 2 0 1 0 4 0V3a2 2 0 0 0-2-2z" />
    <path d="M3 7a5.002 5.002 0 0 0 4 4.9V15h2v-3.1A5.002 5.002 0 0 0 13 7h-1a4 4 0 0 1-8 0H3z" />
  </svg>
);
export default IconMicSizeS;
